import { ContactShadows, Environment } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { ApplicationTypes } from 'awr-domain'
import { useSnackbar } from 'notistack'
import { useEffect } from 'react'

import { useResourceUrl } from '@salsita-ai/platform-project-sdk/react'
import { useResponsive } from '@salsita-ai/platform-project-sdk/ui'

import { configuratorInterface } from '../systems/configurator-interface.js'

// import { useRotationHelper } from './use-dev-rotation-helper.js'
// import { useCameraDevPersistence } from './use-camera-dev-persistence.js'

export default configuratorInterface.createCustomPhoenixLayoutElement('SceneEnvironment', () => {
  const { gl } = useThree()

  useEffect(() => {
    gl.toneMappingExposure = 1
  }, [gl])

  const { accessInfo } = configuratorInterface.useAccessService()
  const { getResourceUrl } = useResourceUrl()
  const activeNavigationState = configuratorInterface.useActiveNavigationState()

  const { isMobile } = useResponsive()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  useEffect(() => {
    if (!accessInfo.viewMode && isMobile && activeNavigationState === ApplicationTypes.NavigationState.Build) {
      const snackbar = enqueueSnackbar('Drawing on mobile does not provide a good experience. Use a desktop instead.', {
        variant: 'warning',
        autoHideDuration: null,
      })

      return () => {
        closeSnackbar(snackbar)
      }
    }

    return () => {}
  }, [isMobile, enqueueSnackbar, closeSnackbar, activeNavigationState, accessInfo.viewMode])

  // useCameraDevPersistence()
  // useRotationHelper()

  return (
    <>
      <ambientLight intensity={1.5} />
      <directionalLight position={[10000, 5000, 4000]} intensity={1} />
      <directionalLight position={[-10000, 5000, 4000]} intensity={1} />
      <Environment files={getResourceUrl('environments/interior_haussmannian_front_day_light_07.hdr')} />
      <ContactShadows
        position={[0, -20, 0]}
        blur={0.25}
        opacity={0.5}
        near={10}
        far={45000}
        width={20000}
        height={20000}
      />
    </>
  )
})
